/// <reference path="../HTML/Tag.ts" />
namespace HA.Core.Entity {
    import Tag = HA.Core.HTML.Tag;
    import Container = HA.Core.HTML.Container;

    export class PageBody extends Entity {

        /**
         * @param names
         * @returns {Map<any, any>}
         */
        public getAttributes(names: string[]) {
            return this.getTag().getAttributes(names, true);
        }

        /**
         * @param menuData
         */
        public showAppMenu(menuData: Array<Map<any, any>>) {
            this.getAppMenuManager().show(menuData);
        }

        public reloadNav(nav: HANavigationApp): void {
            this.getAppManager().reloadNav(nav);
            this.getNavigationAppManager().update(nav);
        }

        /**
         *
         * @param app
         */
        public showApp(app: App) {
            this.getNavigationAppManager().show();
            if (app instanceof HAApp) {
                this.getNavigationAppManager().update(app.getNavigation());
            } else if (app instanceof FSApp) {
                this.getNavigationAppManager().hide();
            }

            this.getAppManager().update(app);
        }

        public getAppManager(): AppManager {
            return this.get("ha.appManager");
        }

        public getAppMenuManager(): AppMenuManager {
            return this.get("ha.appMenuManager");
        }

        /**
         *
         * @returns {HANotification}
         */
        public getNotification() {
            return this.getService("ha.service.webpage").notification();
        }

        /**
         * @returns {Tag}
         */
        public getTag(): any {
            return this.get("horapp");
        }

        /**
         *
         * @returns {NavigationAppManager}
         */
        protected getNavigationAppManager(): NavigationAppManager {
            return this.get("ha.navigationAppManager");
        }

        /**
         * @param navigationAppManager
         * @returns {Map<String, any>}
         */
        protected setNavigationAppManager(navigationAppManager: NavigationAppManager) {
            return this.addToData("ha.navigationAppManager", navigationAppManager);
        }

        /**
         * @param app
         * @returns {Map<String, any>}
         */
        protected setAppManager(app: AppManager) {
            return this.addToData("ha.appManager", app);
        }

        /**
         *
         * @param app
         * @returns {Map<String, any>}
         */
        protected setAppMenuManager(app: AppMenuManager) {
            return this.addToData("ha.appMenuManager", app);
        }

        /**
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addToData("horapp", new Tag(toMap({attribute: "horapp"})));
            this.setNavigationAppManager(new NavigationAppManager({attribute: "navigations"}));
            this.setAppManager(new AppManager({attribute: "apps"}));
            this.setAppMenuManager(new AppMenuManager({services: this.get("services"), attribute: "appmenu"}));
            const notificationContainer = new Container({className: "hanotification"});
            this.getNotification().setMainContainer(notificationContainer);
            this.getTag().insertOnTop(notificationContainer);
        }
    }
}
